import { render, staticRenderFns } from "./SaveIsfTplDialog.vue?vue&type=template&id=6b635ee4&scoped=true"
import script from "./SaveIsfTplDialog.vue?vue&type=script&lang=js"
export * from "./SaveIsfTplDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveIsfTplDialog.vue?vue&type=style&index=0&id=6b635ee4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b635ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b635ee4')) {
      api.createRecord('6b635ee4', component.options)
    } else {
      api.reload('6b635ee4', component.options)
    }
    module.hot.accept("./SaveIsfTplDialog.vue?vue&type=template&id=6b635ee4&scoped=true", function () {
      api.rerender('6b635ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/SaveIsfTplDialog.vue"
export default component.exports